import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { cancelSubscription } from 'actions/billing'

class CancelSubscriptionItem extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!window.confirm('Cancel this subscription? This cannot be undone.')) return
    this.props.cancel(this.props.billingSubscription.id)
  }

  render () {
    const { billingSubscription } = this.props
    if (billingSubscription.status === 'cancelled') return null

    return (
      <Menu.Item onClick={this.handleClick} title="Cancel">
        <Icon name="ban"/>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  cancel: (id) => dispatch(cancelSubscription(id))
})

export default connect(null, mapDispatchToProps)(CancelSubscriptionItem)
